import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IAIWorkspaceRequest, ICreateScriptGenerateRequestPayload } from "../types";

const QUERY_OPTIONS = {
  skipInvalidation: false,
};

export function useCreateScriptGenerateRequest(
  onSuccess?: (data: BackednResponse<IAIWorkspaceRequest>) => void
) {
  const createScriptGenerateRequest = useCallback(
    (payload: ICreateScriptGenerateRequestPayload) =>
      AiWorkspaceService.createScriptGenerateRequest(payload)
        .then((res) => {
          ToastService.success("Script generation request created");
          return res;
        })
        .catch(async (err) => {
          let errorMessage = "Failed to create script generation request";
          if (err?.response) {
            try {
              const responseBody = await err.response.json();
              if (responseBody?.msg) errorMessage = responseBody.msg;
            } catch (e) {}
          }
          ToastService.error(errorMessage);
          throw err;
        }),
    []
  );

  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<ICreateScriptGenerateRequestPayload, BackednResponse<IAIWorkspaceRequest>>({
    mutationFn: createScriptGenerateRequest,
    options: QUERY_OPTIONS,
    onSuccess: (c, data) => {
      c.invalidateQueries({ queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS] });
      c.invalidateQueries({ queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUEST] });
      onSuccess?.(data);
    },
  });

  return { create, isCreating, isCreated };
}
